import apiClient from "./BaseService";
import { EMPLOYEE_URL, URL } from "../config";

let isEmployee = window.location.hostname?.split('.')[0]?.startsWith('emp');
console.log("isEmployee", isEmployee, EMPLOYEE_URL.GET_EMP_NOTIFICATION);

const _getNotification = async (is_read: any, page: number, limit: number, emp_id: any) => {
    if (isEmployee) {
        return apiClient.get(`${EMPLOYEE_URL.GET_EMP_NOTIFICATION}?${is_read != null ? `is_read=${is_read}` : ''}&p=${page}&page_size=${limit}${emp_id ? `&emp_id=${emp_id}` : ''}`)
    }
    else {
        return apiClient.get(`${URL.GET_NOTIFICATION}?${is_read != null ? `is_read=${is_read}` : ''}&p=${page}&page_size=${limit}`)
    }
}

const _toggleNotification = async (action: string, data: any) => {
    return apiClient.patch(`${URL.TOGGLE_NOTIFICATION}?action=${action}`, data)
}

export const NotificationService = {
    _getNotification,
    _toggleNotification
}

